<div class="space-y-10">

  <!-- document type -->
  <div>
    <app-select-input [formGroup]="eventForm" id="documentType" [options]="documents"
                      [formError]="apiErrors.get('documentType')"
                      label="Tipo do Documento (Obrigatório)"></app-select-input>
  </div>

  <!-- document entity -->
  <div>
    <app-text-input [formGroup]="eventForm" id="documentEntity" [maxLength]="50"
                    label="Entidade Emissora"
                    [value]="eventForm.value?.documentEntity" [formError]="apiErrors.get('documentEntity')">
    </app-text-input>
  </div>

</div>
